<template>
   <div class="row justify-content-start card-form-row py-3 my-3">
      <div class="col-6">
         <div class="row">
            <div class="col-12">
               <span class="card-form-field-label">Tipo de Proceso Electoral<span class="required-icon">*</span></span>
            </div>
         </div>
         <div class="row">
            <div class="col-6">
               <RadioButton id="procesoTipo" name="procesoTipo" :value="1" v-model="idProcesoElectoral" @change="getProcesosElectorales" />
               <label for="procesoTipo" class="card-form-field-radio-label">Proceso Electoral Ordinario</label>
            </div>
            <div class="col-6">
               <RadioButton id="procesoTipo" name="procesoTipo" :value="2" :style="{cursor: disableProcesoExt ? 'default' : 'pointer'}" :disabled="disableProcesoExt" v-model="idProcesoElectoral" @change="getProcesosElectorales" />
               <label for="procesoTipo" :style="{color: disableProcesoExt ? '#6c757d' : ''}" class="card-form-field-radio-label">Proceso Electoral Extraordinario</label>
            </div>
         </div>
      </div>
      <div class="col-2">
         <div class="row">
            <div class="col-12">
               <span class="card-form-field-label">Año de proceso electoral<span class="required-icon">*</span></span>
            </div>
         </div>
         <div class="row">
            <div class="col-12">
               <DropDown
                  v-model="idProcesoGeneral"
                  :options="procesosGenerales"
                  :filter="true"
                  panelClass="card-form-field-select"
                  optionLabel="DESCRIPCION"
                  @change="getAmbitos"
                  optionValue="ID_PROCESO_GENERAL"
                  placeholder="Selecciona una opción"
                  emptyMessage="Sin datos"
                  class="w-100"
               />
            </div>
         </div>
      </div>
      <div class="col-2">
         <div class="row">
            <div class="col-12">
               <span class="card-form-field-label">Ámbito<span class="required-icon">*</span></span>
            </div>
         </div>
         <div class="row">
            <div class="col-6" v-if="hayAmbitoFederal">
               <span class="resultcard-link" style="cursor: pointer" v-tooltip.right="etiquetaFederal">
                  <RadioButton id="ambito" name="ambito" :value="1" v-model="ambito" @change="getEntidades" />
                  <label for="ambito" class="card-form-field-radio-label">Federal</label>
               </span>
            </div>
            <div class="col-6" v-if="hayAmbitoLocal">
               <span class="resultcard-link" style="cursor: pointer" v-tooltip.right="etiquetaLocal">
                  <RadioButton id="ambito" name="ambito" :value="2" v-model="ambito" @change="getEntidades" />
                  <label for="ambito" class="card-form-field-radio-label">Local</label>
               </span>
            </div>
         </div>
      </div>
      <div class="col-2">
         <div class="row">
            <div class="col-12">
               <span class="card-form-field-label" > {{ etiquetaEstado }}<span class="required-icon">*</span></span>
            </div>
         </div>
         <div class="row">
            <div class="col-12">
               <DropDown
                  v-model="idEstado"
                  :options="entidades"
                  :filter="true"
                  optionLabel="ESTADO"
                  @change="actualizarFiltrosSecundarios"
                  optionValue="ID_ESTADO"
                  placeholder="Selecciona una entidad"
                  emptyMessage="Sin datos"
                  class="w-100"
               />
            </div>
         </div>
      </div>
   </div>
   <div class="row justify-content-start card-form-row py-3 my-3">
      <div class="col-12">
         <div class="row">
            <div class="col-3">
               <span class="card-form-subtitle">Búsqueda avanzada</span>
            </div>
         </div>
         <div class="row my-3">
            <div class="col-4">
               <div class="row">
                  <div class="col-12">
                     <span class="card-form-field-label">Actor político</span>
                     <img class="" src="../assets/images/help-icon.svg" @click="openActorDialog" style="cursor: pointer; width:16px; height:16px; margin-left: 0.5rem; margin-bottom: 0.25rem;" />
                  </div>
               </div>
               <div class="row">
                  <div class="col-12">
                     <DropDown
                        v-model="idSujetoObligado"
                        :options="actores"
                        :filter="true"
                        optionLabel="NOMBRE_ASOCIACION"
                        optionValue="ID_SUJETO_OBLIGADO"
                        placeholder="Todos los actores políticos"
                        emptyMessage="Sin datos"
                        class="w-100"
                        @change="actualizarFiltrosActores"
                     />
                  </div>
               </div>
            </div>
            <div class="col-4">
               <div class="row">
                  <div class="col-12">
                     <span class="card-form-field-label">Cargo</span>
                  </div>
               </div>
               <div class="row">
                  <div class="col-12">
                     <DropDown
                        v-model="idTipoCandidatura"
                        :options="cargos"
                        :filter="true"
                        optionLabel="NOMBRE_CORTO"
                        optionValue="ID_TIPO_CANDIDATURA"
                        placeholder="Todos los cargos"
                        emptyMessage="Sin datos"
                        class="w-100"
                        @change="actualizarFiltrosCargos"
                     />
                  </div>
               </div>
            </div>
            <div class="col-4">
               <div class="row">
                  <div class="col-12">
                     <span class="card-form-field-label">Municipio</span>
                  </div>
               </div>
               <div class="row">
                  <div class="col-12">
                     <DropDown
                        v-model="idMunicipio"
                        :options="municipios"
                        :filter="true"
                        optionLabel="MUNICIPIO"
                        optionValue="ID_MUNICIPIO"
                        placeholder="Todos los municipios"
                        emptyMessage="Sin datos"
                        class="w-100"
                        @change="actualizarFiltrosMuncipios"
                     />
                  </div>
               </div>
            </div>
         </div>
         <div class="row my-3">
            <div class="col-4">
               <div class="row">
                  <div class="col-12">
                     <span class="card-form-field-label">Distrito</span>
                  </div>
               </div>
               <div class="row">
                  <div class="col-12">
                     <DropDown
                        v-model="idDistrito"
                        :options="distritos"
                        :filter="true"
                        optionLabel="DISTRITO"
                        optionValue="ID_DISTRITO"
                        placeholder="Todos los distritos"
                        emptyMessage="Sin datos"
                        class="w-100"
                        @change="sincronizar"
                     />
                  </div>
               </div>
            </div>
            <div class="col-4"></div>
         </div>
      </div>
   </div>

   <PrimeDialog
      header="¿Qué es un Actor Político?"
      v-model:visible="actorDialog"
      :breakpoints="{ '500px': '75vw', '640px': '90vw' }"
      :style="{ width: '578px' }"
   >
      <template #header>
         <span class="consulta-process-dialog-header w-100">¿Qué es un Actor Político?</span>
      </template>
      <div class="row">
         <div class="col-12">
            <table class="mx-4">
               <tr>
                  <td style="vertical-align: top">
                     <img class="mx-3" width="50" height="50" src="../assets/images/actor_icon.svg" />
                  </td>
                  <td>
                     <p class="consulta-process-dialog-text">
                        Son aquellos que cuentan con registro ante el INE y tienen el derecho de participar en elecciones federales (Presidencia,
                        Senadurías y Diputaciones), así como en elecciones locales (Gubernaturas, Diputaciones y Ayuntamientos).
                     </p>
                  </td>
               </tr>
            </table>
         </div>
      </div>
   </PrimeDialog>
</template>

<script setup>
import { defineProps, onMounted, ref, defineExpose } from "vue";
import FiltersDataService from "@/service/FiltersDataService";
import FiltersService from "@/service/FiltersService";
import AppConfig from "@/conf/global";

let idProceso = ref(0);
let idProcesoElectoral = ref(1);
let idProcesoGeneral = ref();
let disableProcesoExt = ref(false)
let ambito = ref(null);
let idEstado = ref(0);
let idMunicipio = ref(null);
let idSujetoObligado = ref(null);
let idTipoCandidatura = ref(null);
let idDistrito = ref(null);
let descripcion = ref(null);

let procesosGenerales = ref([]);
let ambitos = ref([]);
let entidades = ref([]);
let municipios = ref([]);
let distritos = ref([]);
let cargos = ref([]);
let actores = ref([]);

let hayAmbitoFederal = ref(false);
let hayAmbitoLocal = ref(false);

const actorDialog = ref(false);

const secondary = ref(false);
const backendChecked = ref(false);
const showResultDatatable = ref(false);

const etiquetaFederal = ref(
   "Información de los actores políticos que se postulan para los cargos de Presidencia de la República, Senadurías y Diputaciones Federales"
);
const etiquetaLocal = ref("Información de los actores políticos que se postulan para los cargos de elección en la entidad");

let etiquetaEstado= ref(
   ""
);

const props = defineProps({
   idProceso: Number,
   checkAjax: Function,
   addAjax: Function,
   removeAjax: Function,
   load500Error: Function,
   sincronizar: Function,
});

onMounted(() => {
   idProceso.value = props.idProceso;
   checkBackend();
});

const checkBackend = () => {
   //console.log("checkBackend: " + secondary.value);
   sincronizar();
   if (!backendChecked.value) {
      FiltersDataService.getInfo(secondary.value)
         .catch(() => {
            if (!secondary.value) {
               secondary.value = true;
               checkBackend();
            }
         })
         .finally(() => {
            backendChecked.value = true;
            init();
         });
   } else {
      //console.log("init");
      init();
   }
};

const init = () => {
   getProcesosElectorales();
   props.checkAjax();
};

const changeProcess = (parIdProceso) => {
   idProceso.value = parIdProceso;
   checkBackend();
};

defineExpose({
   changeProcess,
});

// const getProcesos = () => {
//    // console.log("getProcesos: " + backendChecked.value + " secondary: " + secondary.value)
//    FiltersDataService.getProcesos(secondary.value, idProceso.value, idProcesoGeneral.value)
//       .then((res) => {
//          // disableProcesoExt.value = FiltersService.disableProcesoExt(res.data.body)
//          let lista = FiltersService.disableProcesoExt(res.data.body);
//          console.log("body:", res.data.body);
//          console.log("procesos:", lista);
//          if (!lista)
//             disableProcesoExt.value = true;
//          else
//             disableProcesoExt.value = false;
//       })
//       .catch((err) => {
//          console.log(err)
//       })
// };


const getProcesosValidacion = () => {
   // console.log("getProcesos: " + backendChecked.value + " secondary: " + secondary.value)
   FiltersDataService.getProcesosValidacion(secondary.value, idProceso.value, 2)
      .then((res) => {
         let lista = FiltersService.disableProcesoExt(res.data.body);
         console.log("body-validacion:", res.data.body);
         console.log("procesos-validacion", lista);
         if (!lista)
            disableProcesoExt.value = true;
         else
            disableProcesoExt.value = false;
      })
      .catch((err) => {
         console.log(err)
      })
};


const getProcesosElectorales = () => {
   // console.log("getProcesosElectorales checked: " + backendChecked.value + " secondary: " + secondary.value);
   props.addAjax();
   FiltersDataService.getProcesosElectorales(secondary.value, idProceso.value, idProcesoElectoral.value)
      .then((res) => {
         procesosGenerales.value = res.data.body;
         setProcesoElectoral();
         sincronizar();
         props.removeAjax();
         getAmbitos();
         //getProcesos();
         getProcesosValidacion();
      })
      .catch((err) => {
         props.removeAjax();
         console.log(err);
         props.load500Error(err);
      });
};

const setProcesoElectoral = () => {
   //console.log("descripcion 1: " + descripcion.value);
   if (procesosGenerales.value.length > 0) {
      const previousId = idProcesoGeneral.value;
      const searchItem = FiltersService.findProcesoElectoral(procesosGenerales.value, previousId);
      if (searchItem == undefined) {
         idProcesoGeneral.value = procesosGenerales.value[0].ID_PROCESO_GENERAL;
         descripcion.value = procesosGenerales.value[0].DESCRIPCION;
      } else {
         idProcesoGeneral.value = searchItem.ID_PROCESO_GENERAL;
         descripcion.value = searchItem.DESCRIPCION;
      }
   } else {
      idProcesoGeneral.value = 0;
      descripcion.value = "";
   }
   //console.log("descripcion 2: " + descripcion.value);
};

const getAmbitos = async () => {
   props.addAjax();
   setProcesoElectoral();
   await FiltersDataService.getAmbitos(secondary.value, idProceso.value, idProcesoElectoral.value, idProcesoGeneral.value)
      .then((res) => {
         const previousId = ambito.value;
         ambitos.value = res.data.body;
         if (ambitos.value.length == 0) {
            hayAmbitoFederal.value = false;
            hayAmbitoLocal.value = true;
            ambito.value = AppConfig.ambitoLocal;
            
         } else {
            const searchItem = FiltersService.findAmbito(ambitos.value, previousId);
            if (searchItem == undefined) ambito.value = ambitos.value[0].ID_AMBITO;
            else ambito.value = searchItem.ID_AMBITO;

            const searchAmbitoFederal = FiltersService.findAmbito(ambitos.value, AppConfig.ambitoFederal);
            const searchAmbitoLocal = FiltersService.findAmbito(ambitos.value, AppConfig.ambitoLocal);
            if (searchAmbitoFederal != undefined) hayAmbitoFederal.value = true;
            else hayAmbitoFederal.value = false;
            if (searchAmbitoLocal != undefined) hayAmbitoLocal.value = true;
            else hayAmbitoLocal.value = false;

         }
         props.removeAjax();
      

         sincronizar();
         getEntidades();
      })
      .catch((err) => {
         console.log(err);
         props.removeAjax();
         props.load500Error(err);
      });
};

const getEntidades = async () => {
   props.addAjax();
   await FiltersDataService.getEntidades(secondary.value, idProceso.value, idProcesoElectoral.value, idProcesoGeneral.value, ambito.value)
      .then((res) => {
         entidades.value = res.data.body;
         if (entidades.value.length > 0) {
            idEstado.value = entidades.value[0].ID_ESTADO;
           
         } else {
            idEstado.value = 0;
         }
		showResultDatatable.value = false;
         sincronizar();
         props.removeAjax();
         actualizarFiltrosSecundarios();
      })
      .catch((err) => {
         props.removeAjax();
         console.log(err);
         props.load500Error(err);
      });
};

const actualizarFiltrosSecundarios = () => {
   getMunicipios();
   getDistritos();
   getActoresPoliticos();
   getCargos();
};

const actualizarFiltrosActores = () => {
   sincronizar();
   getMunicipios();
   getDistritos();
   getCargos();
};

const actualizarFiltrosCargos = () => {
   sincronizar();
   getMunicipios();
   getDistritos();
};

const actualizarFiltrosMuncipios = () => {
   sincronizar();
   getDistritos();
};

const getMunicipios = async () => {
   props.addAjax();
   await FiltersDataService.getMunicipios(secondary.value, params)
      .then((res) => {
         municipios.value = res.data.body;
         if (municipios.value.length > 0) {
            idMunicipio.value = municipios.value[0].ID_MUNICIPIO; 
         } else idMunicipio.value = null;
         sincronizar();
         props.removeAjax();
         getDistritos();
      })
      .catch((err) => {
         props.removeAjax();
         console.log(err);
         props.load500Error(err);
      });
};

const getDistritos = async () => {
   props.addAjax();
   await FiltersDataService.getDistritos(secondary.value, params)
      .then((res) => {
         distritos.value = res.data.body;
         if (distritos.value.length > 0) {
            idDistrito.value = distritos.value[0].ID_DISTRITO;
         } else idDistrito.value = null;
         sincronizar();
         props.removeAjax();
      })
      .catch((err) => {
         console.log(err);
         props.removeAjax();
         props.load500Error(err);
      });
};

const getActoresPoliticos =  () => {
   props.addAjax();
   FiltersDataService.getActoresPoliticos(
      secondary.value,
      idProceso.value,
      idProcesoElectoral.value,
      idProcesoGeneral.value,
      ambito.value,
      idEstado.value,
      idMunicipio.value
   )
      .then((res) => {
         actores.value = res.data.body;
         if (actores.value.length > 0) {
            idSujetoObligado.value = actores.value[0].ID_SUJETO_OBLIGADO;
         } else idSujetoObligado.value = null;
         sincronizar();
         props.removeAjax();
         getMunicipios();
         getDistritos();
         getCargos();
         
      })
      .catch((err) => {
         console.log(err);
         props.removeAjax();
         props.load500Error(err);
      });
};

let params = FiltersDataService.setFilters(
      idProceso.value,
      idProcesoElectoral.value,
      idProcesoGeneral.value,
      ambito.value,
      idEstado.value,
      idMunicipio.value,
      idSujetoObligado.value,
      idTipoCandidatura.value, 
      idDistrito.value
   );

const getCargos = async () => {
   props.addAjax();

   await FiltersDataService.getCargos(
      secondary.value,
      params
   )
      .then((res) => {
         cargos.value = res.data.body;
         if (cargos.value.length > 0) {
            idTipoCandidatura.value = cargos.value[0].ID_TIPO_CANDIDATURA;
         } else idTipoCandidatura.value = null;
         sincronizar();
         props.removeAjax();
         getMunicipios();
         getDistritos();
      })
      .catch((err) => {
         console.log(err);
         props.removeAjax();
         props.load500Error(err);
      });
};

const sincronizar = () => {
   props.sincronizar(
      idProcesoElectoral.value,
      idProcesoGeneral.value,
      ambito.value,
      idEstado.value,
      idMunicipio.value,
      idSujetoObligado.value,
      idTipoCandidatura.value,
      idDistrito.value,
      descripcion.value,
      showResultDatatable.value 
   );
    params = FiltersDataService.setFiltersSecundarios(
      idProceso.value,
      idProcesoElectoral.value,
      idProcesoGeneral.value,
      ambito.value,
      idEstado.value,
      idMunicipio.value,
      idSujetoObligado.value,
      idTipoCandidatura.value, 
      idDistrito.value
   );

      if (ambito.value==1){
         etiquetaEstado.value="Entidad / Circunscripción";
         }
      
      if (ambito.value==2){
         etiquetaEstado.value="Entidad";
         }
};

const openActorDialog = () => {
   actorDialog.value = true;
};
</script>